<template>
  <div>
    <div v-if="isLoading" class="spinner-container">
      <div class="spinner"></div>
    </div>
    <div class="container-fluid overflow-auto">
      <div class="row">
        <div class="col-12 pt-3 pb-3 pl-4">
          <h3><i class="fa fa-headset"></i> Central Atendimento</h3>
        </div>
      </div>
      <div class="d-flex flex-wrap" v-if="localConversations && localConversations.length > 0">
        <div class="our-team-main"  v-for="conversation in localConversations" :key="conversation.conversationId">
          <div>
            <div class="team-front">
              <div class="perfilInfos" @click="openAttachModalMessages(conversation.conversationId)">
                <img :src="getAvatar(conversation.photo)"/>
                <div class="name" :title="getDisplayName(conversation)">
                {{ getDisplayName(conversation) }}
                </div>
                <label for="Telefone">{{ conversation.formattedPhone ? 'Telefone: ' + conversation.formattedPhone : 'Usuário não possui telefone' }}</label>
                <label for="Data">Aberto em {{ formatDate(conversation.createdAt) }}</label>
                <label for="GerenteRelacionamento">{{ conversation.personDetails.gerenteRelacionamento ? 'Gerente Relacionamento: ' + conversation.personDetails.gerenteRelacionamento : 'Nenhum' }}</label>
              </div>
              <div class="buttons-container">
                <defaultbutton
                  class="defaultbutton col-12"
                  :onClick="() => openAttachModalMessages(conversation.conversationId)"
                  btnVariant="btn-third"
                  icon="fas fa-comments"
                  text="mensagem"
                />
                <defaultbutton
                  class="defaultbutton col-12"
                  :onClick="() => openAttachModal(conversation)"
                  btnVariant="btn-third"
                  icon="fas fa-arrow-right"
                  text="transferir"
                  :title="conversation.botId === 'NDA' ? 'Transferir' : 'Não é possível transferir, pois está sendo atendido pelo bot'"
                  :disabled="conversation.botId !== 'NDA'"
                />
                <defaultbutton
                  class="defaultbutton col-12"
                  :onClick="() => sendAssumeOperator(conversation)"
                  btnVariant="btn-third"
                  icon="fa fa-user-check"
                  text="assumir"
                  :title="conversation.botId === 'NDA' ? 'Assumir' : 'Não é possível assumir, pois está sendo atendido pelo bot'"
                  :disabled="conversation.botId !== 'NDA'"
                />
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal centered ref="modal-new" v-model="showModalTransfer" title="Transferir">
      <label for="username-select">Selecione um usuário:</label>
      <b-form-select id="username-select" v-model="selectedUsername" :options="usernames"></b-form-select>
      <label style="margin-top:10px" for="observation">Observação:</label>
      <toogleswitch style="margin-top: 10px;" v-model="createObservation" label="Adicionar Observação" />
      <div v-show="createObservation">
        <div style="margin-top: 10px;">
          <b-form-textarea id="observation" v-model="observationTranfer" placeholder="Observação" maxlength="45"
          ></b-form-textarea>
        </div>
      </div>
      <template #modal-footer>
        <div class="w-100 text-right">
          <button type="button" class="btn btn-third btn-sm" v-on:click="sendUpdateOperator(conversation)"  v-b-tooltip.hover
            :title="'Transferir'"><i class="fa fa-angle-double-right"></i><span class="d-md-down-none">  Transferir</span></button>
        </div>
      </template>
    </b-modal>
    <b-modal centered v-model="showModalMessages" ref="messages-history">
      <div class="col-12 pt-3 pb-3 pl-4">
          <h3><i class="fa fa-comments"></i> Mensagem</h3>
        </div>
      <div class="modal-content">
      <ChatMessages
      v-show="showModalMessages"
      ref="chatMessages"
      :messages="messages"
    />
      </div>
      <template #modal-footer>
        <div class="w-100 text-right">
          <button type="button" class="btn btn-third btn-sm" v-on:click="showModalMessages = false"  v-b-tooltip.hover
            :title="'OK'"><i class="fa "></i><span class="d-md-down-none">Ok</span></button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import ConversationsSearch from './ConversationsSearch.vue'
import AtendimentoRepository from '@/shared/http/repositories/atendimento/atendimento'
import AccountMixin from '@/store/module/account/mixin'
import ChatMessages from '@/views/private/atendimento/central_atendimento/components/chat/ChatMessages.vue'
import defaultbutton from '@/components/UI/button/defaultButton.vue'
import toogleswitch from '@/components/UI/toogleSwitch/toogleSwitch.vue'

import _ from 'lodash'

export default {
  name: 'Messages',
  components: {
    ConversationsSearch,
    ChatMessages,
    defaultbutton,
    toogleswitch
  },
  props: {
    conversations: {
      type: Array,
      required: true
    }
  },
  mixins: [AccountMixin],
  person: {
    type: Object,
    required: false,
    default: () => null
  },
  data () {
    return {
      localConversations: [],
      isLoading: false,
      searchText: '',
      showModalTransfer: false,
      usernames: [],
      messages: [],
      showModalMessages: false,
      selectedUsername: null,
      selectedConversationId: null,
      observationTranfer: null,
      dialog: false,
      createObservation: false
    }
  },
  async mounted () {
    this.addDetailsConversation()
  },
  computed: {
    filteredConversations () {
      return this.conversations.filter(conversation => {
        return conversation.name.nome.toLowerCase().includes(this.searchText.toLowerCase()) || conversation.conversationId.toString().toLowerCase().includes(this.searchText.toLowerCase()) || conversation.identifier.toString().toLowerCase().includes(this.searchText.toLowerCase().replace(/\D/g, ''))
      })
    }
  },
  watch: {
    isLoading (newValue) {
      this.$emit('loading-changed', newValue)
    },
    conversations: {
      handler () {
        this.addDetailsConversation()
      },
      deep: true
    }
  },
  showWarning () {
    this.$bvToast.toast('Não é possível realizar esta ação pois está sendo atendida pelo bot.', {
      title: 'Atendimento sendo realizado pelo bot',
      variant: 'danger',
      solid: true
    })
  },
  created () {
    this.getUsernames()
  },
  methods: {
    getAvatar (encodedImage) {
      if (encodedImage) {
        return `data:image/png;base64,${encodedImage}`
      }

      return '/static/img/avatars/03.png'
    },
    getDisplayName (conversation) {
      let name = 'Usuário não possui nome'
      if (conversation.name.nome) {
        name = conversation.name.nome
      }
      return name
    },
    sendUpdateOperator (conversation) {
      console.log(conversation)
      const message = {
        conversationId: conversation.conversationId,
        username: this.selectedUsername.username,
        nameOperator: this.selectedUsername.nome.replace('\t', ''),
        identifier: conversation.identifier,
        name: conversation.name,
        provider: conversation.provider,
        event: 'transferir',
        deptoId: this.account.funcionario.paId[0],
        protocol: conversation.protocol,
        description: this.observationTranfer
      }
      this.$emit('sendUpdateOperator', message)
    },
    sendAssumeOperator (conversation) {
      const message = {
        conversationId: conversation.conversationId,
        username: this.account.username,
        nameOperator: this.account.pessoa.nome.replace('\t', ''),
        identifier: conversation.identifier,
        name: conversation.name,
        provider: conversation.provider,
        event: 'assumir',
        deptoId: this.account.funcionario.paId[0],
        protocol: conversation.protocol,
        description: 'Atendimento assumido pelo operador'
      }
      console.log(message)
      this.$router.push('/atendimento')
      this.$emit('sendAssumeOperator', message)
    },
    openAttachModal (conversation) {
      this.conversation = conversation
      this.showModalTransfer = true
    },
    formatDocument (document) {
      if (!document) {
        return 'Usuário não possui documento'
      }

      let formattedDocument = document
      let documentType = ''

      if (document.length === 11) {
        formattedDocument = document.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
        documentType = 'CPF '
      } else if (document.length === 14) {
        formattedDocument = document.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
        documentType = 'CNPJ '
      }

      return documentType + formattedDocument
    },
    async getUsernames () {
      const requestConfig = {
        params: {
          paId: this.account.funcionario.paId[0],
          modules: 'OPERADOR_ATENDIMENTO'
        }
      }
      await AtendimentoRepository.GetUsenames(requestConfig)
        .then(response => {
          const { data } = response
          console.log(data)
          this.usernames = data.usernames.map(username => {
            return { text: username.nome, value: { username: username.username, nome: username.nome } }
          })
        })
        .catch(error => {
          console.error(error)
        })
        .finally(() => {
        })
    },
    formatDate (date) {
      let d = new Date(date)
      return d.toLocaleDateString('pt-BR', { hour: '2-digit', minute: '2-digit', second: '2-digit' })
    },
    async addDetailsConversation () {
      this.isLoading = true
      for (let i = 0; i < this.conversations.length; i++) {
        const conversation = this.conversations[i]
        const personDetails = await this.getDetails(conversation)
        this.localConversations.push({ ...conversation, personDetails })
      }
      this.localConversations.sort((b, a) => new Date(b.createdAt) - new Date(a.createdAt))
      this.isLoading = false
    },
    async openAttachModalMessages (conversationId) {
      await Promise.all([
        this.messages = this.getMessages(conversationId)
      ])
      this.showModalMessages = true
    },
    async getMessages (conversationId) {
      if (conversationId !== null) {
        await AtendimentoRepository.GetConversationMessages(conversationId)
          .then(response => {
            const { data } = response
            let messages = []

            if (data && data.length > 0) {
              messages = data
                .map((message, index) => {
                  return {
                    ...message,
                    sent: true,
                    order: index
                  }
                })
            }
            console.log(messages)
            this.messages = messages
          })
          .catch(error => {
            console.error(error)
          })
      }
    },
    async getDetails (conversation) {
      if (conversation.personDetails) {
        return conversation.personDetails
      }
      try {
        let response = await AtendimentoRepository.GetPersonDetails(conversation.conversationId, { params: { phone: conversation.formattedPhone } })
        const { status, data } = response

        if (status === 200 && !_.isNil(data) && !_.isEmpty(data)) {
          console.log(data)
          return data
        } else {
          this.isLoading = false
          return null
        }
      } catch (error) {
        console.error(error)
        return null
      }
    }
  }
}
</script>
<style lang="scss" scoped>

.container-fluid {
  height: 100%;
  overflow: auto;
  scrollbar-width: thin;
  scrollbar-color: #0BACA0 transparent;
}

.our-team-main {
  display: flex;
  align-items: center;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
  padding: 10px;
  position: relative;
  margin: 10px;
  gap: 14px;
  max-width: 410px;
  transform: translateZ(0);
  backface-visibility: hidden;
  transition: transform 0.3s ease-in-out;
}

.our-team-main:hover {
  transform: scale(1.05);
}
.photo {
  padding: auto;
  width: 90%;
  height: 90%;
  text-align: left;
}
img {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  border: 1px solid #01d6bd;
}
.perfilInfos {
  width: 100%;
  height: 100%;
  text-align: start;
}
.perfilInfos:hover {
  cursor: pointer;
}
.perfilInfos label {
  font-size: 12px;
  margin-bottom: -3px;
  font-weight: bold;
}
.buttons-container {
    display: flex;
    flex-wrap: wrap;
  }
.defaultbutton {
    margin-bottom: 2px;
}
.team-front {
  display: flex;
  justify-content: space-between;
  padding: 5px 10px;
  max-width: 100%;
}
.name {
  font-size: 17px;
  font-weight: bold;
  color: #1BACA0;
  margin-top: 7px;
  width: 190px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.detailsConversation {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.detailsConversation label {
  font-size: 10px;
  color: #01d6bd;
  margin-bottom: -3px;
  font-weight: bold;
}
.modal-content {
  height: auto;
  width: 100%;
}
.modal-content {
    height: 400px;
    width: 100%;
  }
  .spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-left: 4px solid #1BACA0;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

</style>



// WEBPACK FOOTER //
// src/views/private/atendimento/central_atendimento/components/conversations/Conversations.vue